<template lang="pug">
  .component.component-backoffice-note(v-if="item")
    .card( v-if="$is('listing')")
      .inner-content
        .row
          .column.shrink
            dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
              .dropdown-buttons
                ActionButton(confirm, :action="remove") Delete
          .column
            .label PD{{item.id}}
            .field-value {{item.name}}
          .column
            .label Start
            .value {{item.start}}
          .column
            .label End
            .value {{item.end}}
          .column
            label Capabilities
            .value {{item.capabilities.routes.join(", ")}}
          .column.shrink
            span.fa(:style="hasReservations", :class="what", @click="expanded = !expanded")
        template(v-if="expanded && item.pass_reservations.length")
          h2 Pass reservations
          template(v-for="(reservation,i) in item.pass_reservations")
            .row
              .column
                label Status
                .value {{reservation.status}}
              .column
                label Service date
                .value {{reservation.service_date}}

              .column
                label Booked at
                .value {{reservation.created_at}}
            hr

</template>
<script type="text/babel">
import CardN from 'components/structure/CardN'
import Dropdown from '../structure/foundation/Dropdown'
import VehicleCostButtons from '../structure/ui/actions/VehicleCostButtons'
import VehicleNoteButtons from '../structure/ui/actions/VehicleNoteButtons'
import TocButtons from '../structure/ui/actions/TocButtons'
import ActionButton from "../structure/ui/ActionButton.vue";
import KeplerBackofficeSdk from "../../lib/kepler/backoffice";
import {EventBus} from "../../eventBus";

export default {
  name: 'PassDriver',
  components: {
    ActionButton,
    TocButtons,
    VehicleNoteButtons,
    VehicleCostButtons,
    Dropdown,
    CardN,
  },
  data() {
    return {
      expanded: false
    }
  },
  created() {
  },
  methods: {
    remove() {
      KeplerBackofficeSdk.driverPass.select(this.item.id).delete(() => {
        EventBus.$emit('reload-list')
      })
    },
  },
  computed: {
    what() {
      return this.expanded ? 'fa-arrow-up' : 'fa-arrow-down'
    },
    hasReservations() {
      if (this.item.pass_reservations.length === 0) {
        return {}
      }

      return {
        cursor: "pointer"
      }
    }
  },
  props: {
    item: Object,
    type: {
      type: String,
      default: ''
    }
  },
}
</script>
<style lang="sass" rel="stylesheet/sass">
</style>



// WEBPACK FOOTER //
// PassDriver.vue?3c9c4aea